import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import styles from "./SignaturePad.module.css";
export const SignaturePad = ({ onSave, onCancel }) => {
    const sigPadRef = useRef(null);
    const [isEmpty, setIsEmpty] = useState(true);
    const handleClear = () => {
        sigPadRef.current?.clear();
        setIsEmpty(true);
    };
    const handleSave = () => {
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            const signatureData = sigPadRef.current.toDataURL();
            onSave(signatureData);
        }
    };
    const handleBegin = () => {
        setIsEmpty(false);
    };
    return (_jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.header, children: [_jsx("h3", { className: styles.title, children: "Sign here" }), _jsx("button", { type: "button", onClick: onCancel, className: styles.closeBtn, "aria-label": "Close signature pad", children: "\u00D7" })] }), _jsxs("div", { className: styles.canvasWrapper, children: [_jsx(SignatureCanvas, { ref: sigPadRef, canvasProps: {
                            className: styles.canvas,
                        }, onBegin: handleBegin, backgroundColor: "#ffffff", penColor: "#000000" }), _jsx("div", { className: styles.signLine })] }), _jsxs("div", { className: styles.actions, children: [_jsx("button", { type: "button", onClick: handleClear, className: styles.clearBtn, disabled: isEmpty, children: "Clear" }), _jsx("button", { type: "button", onClick: handleSave, className: styles.saveBtn, disabled: isEmpty, children: "Save Signature" })] })] }));
};
